import { Router } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn:'root'
})
export class OauthGuard {
    constructor(private router: Router){

    }
    canActivate() {
        if(sessionStorage.getItem("currentUserEmail") == null) {
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }
}